module.exports = __webpack_public_path__ + "img/组 35@2x.80cdaee6.png";